import { useEffect, useState } from "react";
import { Eye, Save } from "lucide-react";

import { api, apiError } from "@/lib/api";

const fields = [
  ["show_surface", "Superficie"],
  ["show_price_sqm", "Precio por m²"],
  ["show_total_price", "Precio total"],
  ["show_phase", "Fase"],
];

export default function PublicViewerSettingsPanel() {
  const [settings, setSettings] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    api.get("/public-plan/settings").then((response) => setSettings(response.data));
  }, []);

  const save = async () => {
    try {
      await api.put("/public-plan/settings", settings);
      setMessage("Visibilidad del acceso PSC actualizada.");
    } catch (error) {
      setMessage(apiError(error));
    }
  };

  if (!settings) return null;
  return (
    <section className="public-viewer-settings" data-testid="public-viewer-settings-panel">
      <div className="panel-heading"><div><span className="eyebrow">ACCESO COMPARTIDO</span><h2>Visor PSC</h2></div><Eye size={20} /></div>
      <p>El usuario PSC siempre verá solo lotes disponibles. Elige los datos visibles al cliente.</p>
      <div className="public-viewer-fields">
        {fields.map(([key, label]) => <label key={key}><input checked={settings[key]} data-testid={`public-viewer-${key}`} onChange={() => setSettings({ ...settings, [key]: !settings[key] })} type="checkbox" /> {label}</label>)}
      </div>
      <label className="public-viewer-whatsapp" htmlFor="public-viewer-whatsapp-number">
        WhatsApp comercial (solo números, con código país)
        <input
          data-testid="public-viewer-whatsapp-number"
          id="public-viewer-whatsapp-number"
          onChange={(event) => setSettings({ ...settings, whatsapp_number: event.target.value.replace(/\D/g, "") })}
          value={settings.whatsapp_number || ""}
        />
      </label>
      {message && <p className="form-note" data-testid="public-viewer-settings-message">{message}</p>}
      <button className="primary-button" data-testid="save-public-viewer-settings" onClick={save} type="button"><Save size={16} /> Guardar visibilidad</button>
    </section>
  );
}